<template>
    <section>
        <div class="field">
            <label class="label">{{ label }}</label>
            <div class="control is-flex">
                <input type="number"
                       class="input"
                       v-model="inputid"
                       @change="getId"
                       :readonly="leitura"
                       :disabled="leitura"
                       style="width: 24%;" />

                <b-autocomplete :data="data"
                                icon="magnify"
                                ref="autocomplete"
                                :field="nomeCampo"
                                :loading="isFetching"
                                @typing="getAsyncData"
                                :readonly="leitura"
                                :disabled="leitura"
                                @select="selectItem"
                                :style="autocompleteStyle">
                    <template slot="empty">
                        Nenhum {{ label }} encontrado
                    </template>
                    <template slot-scope="props">
                        <div class="is-flex is-justified-between">
                            <span>{{ props.option[nomeCampo] }}</span>
                            <span class="tag">{{ props.option.id }}</span>
                        </div>
                        <div class="is-flex is-justified-between" v-if="campos && campos.length">
                            <span v-for="item in campos" :key="item.campo">{{item.nome}}: <b>{{ props.option[item.campo] }}</b></span>
                        </div>
                    </template>
                </b-autocomplete>
                <slot></slot>
            </div>
        </div>
    </section>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        props: {
            id: Number,
            nome: String,
            label: String,
            table: String,
            field: null,
            searchField: null,
            leitura: null,
            campos: null
        },
        data() {
            return {
                data: [],
                inputid: this.id,
                isFetching: false,
                nomeCampo: 'nome',
                campoBusca: 'nome'
            }
        },
        mounted() {
            
            this.nomeCampo = this.field ? this.field : this.nomeCampo;
            this.campoBusca = this.searchField ? this.searchField : this.campoBusca;
            if (this.id){
                this.inputid = this.id
                this.getId()
            }
        },
        watch: {
            id() {
                this.inputid = this.id
                this.getId()
            },
            field(){
                this.nomeCampo = this.field ? this.field : this.nomeCampo;
            },
            searchField(){
                this.campoBusca = this.searchField ? this.searchField : this.campoBusca;
            }
        },
        computed: {
            hasDefaultSlot() {
                return !!this.$scopedSlots.default
            },
            autocompleteStyle() {
                return "width: " +
                        (this.hasDefaultSlot
                            ? "69"
                            : "75") + "%"
            }
        },
        methods: {
            getAsyncData: debounce(function (name) {
                if (!name.length) {
                    this.data = []
                    return
                }                
                this.isFetching = true
                this.$http.get(`/Search/${this.table}?${this.campoBusca}=${name}`)
                    .then(({ data }) => {
                        this.data = []
                        data.forEach((item) => this.data.push(item))
                    })
                    .catch((error) => {
                        this.data = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })
            }, 500),
            getId() {
                
                if(this.inputid == ""){                    
                    this.inputid = null;                    
                    this.$refs.autocomplete.setSelected({
                        [this.nomeCampo]: null,
                        data: null
                    });
                    this.$emit('update:id', this.inputid);      
                    this.$emit('update:nome', null);               
                }
                if(this.inputid && !this.isFetching){
                                       
                    this.isFetching = true
                    const idInputAjax = this.inputid;
                    this.$http.get(`/Search/${this.table}Id?id=${this.inputid}`)
                        .then(({ data }) => {
                            if(data.fail){
                                this.$buefy.toast.open({
                                    duration: 3000,
                                    message: this.table + " " + idInputAjax + ' não encontrado.',
                                    type: 'is-danger',
                                    queue: false
                                })
                                this.inputid = null
                                this.$refs.autocomplete.setSelected({
                                    [this.nomeCampo]: null,
                                    data: null
                                })   
                                this.$emit('update:id', this.inputid)  
                                this.$emit('update:nome', null);         
                            }
                            else {
                                this.$emit('update:id', parseInt(this.inputid))  
                                this.$emit('update:nome', data[this.nomeCampo]);         
                                this.$refs.autocomplete.setSelected({
                                    [this.nomeCampo]: data[this.nomeCampo],
                                    data: data
                                })
                            }
                            
                        })
                        .catch((error) => {
                            this.data = []
                            throw error
                        })
                        .finally(() => {
                            this.isFetching = false
                        })
                }
            },            
            selectItem(option) {                
                if (option.id){
                    this.inputid = option.id
                    this.$emit('update:id', option.id)
                    this.$emit('update:nome', option.nome);        
                }
                this.$emit('item', option);
            }
        }
    }
</script>